import React from 'react';
import TargetingSetting from 'components/molecules/TargetingSetting';

const TargetingSettingWrap = (props) => {
  const {
    type,
    handleClickSnackbar,
    allProductCodeList,
    getParam,
    weightList,
    params = {},
  } = props;

  return (
    <div style={{ display: 'inline-block', width: 520 }}>
      {(() => {
        let result = [];
        weightList.forEach((code) => {
          if (!!code) {
            const codeInfo = allProductCodeList.find(
              (element) => element['value'] === code
            );
            result.push(
              <TargetingSetting
                key={code}
                type={type}
                codeInfo={codeInfo}
                params={params}
                getParam={getParam}
                handleClickSnackbar={handleClickSnackbar}
              />
            );
          }
        });
        return result;
      })()}
    </div>
  );
};
export default TargetingSettingWrap;
